module.exports = "/wwwroot/img/notification_block.png?ver=f5a847fa";